// +----------------------------------------------------------------------
// | 认证接口
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 注册
 * @param {{username:string, password:string, nickname?:string}} data
 * @returns {Promise<{token:string, expires_in:number, user:object}>}
 */
export function register(data) {
  return request.post('/auth/register', data);
}

/**
 * 登录
 * @param {{username:string, password:string}} data
 * @returns {Promise<{token:string, expires_in:number, user:object}>}
 */
export function login(data) {
  return request.post('/auth/login', data);
}

/**
 * 退出登录（清空服务端 token）
 */
export function logout() {
  return request.post('/auth/logout');
}

/**
 * 忘记密码：申请重置邮件
 *
 * 注意：后端**防枚举** —— 无论该邮箱有没有绑过账号，都返回同一句话
 * （"如果这个邮箱绑过账号，重置链接已经发出去了"）。
 * 所以前端不要试图区分「邮箱不存在」，照着后端的话术展示就行。
 * 重置链接只进邮件，接口不会回传。
 *
 * @param {string} email
 */
export function forgotPassword(email) {
  return request.post('/auth/forgot', { email });
}

/**
 * 用邮件里的令牌设置新密码（免登录）
 *
 * 成功后会返回 username，且该账号**所有设备一律下线** ——
 * 重置场景分不清哪台是本人，统一让他用新密码重新登录。
 *
 * @param {string} token 邮件链接里 ?token= 的值
 * @param {string} password 新密码
 */
export function resetPassword(token, password) {
  return request.post('/auth/reset', { token, password });
}
